export default {
  coachSSO_iframeTitle: 'Zonar Coaching',
  coachSSO_error_unauthorized:
    'Coaching SSO integration is not active for your company. Contact your administrator.',
  coachSSO_error_notReady:
    'Coaching is not ready for your company yet. Please try again later or contact your administrator.',
  coachSSO_error_noTags:
    'You have no tags that exist in Coaching, so there is nothing to show. Ask your administrator to assign you tags.',
  coachSSO_error_customError:
    'We could not create the Coaching session token. Please try again. If the problem persists, contact support.',
  coachSSO_error_frameLoad:
    'The Coaching module could not be loaded. Please try again later.',
  coachSSO_error_generic: 'Something went wrong while connecting to Coaching. Please try again.',
  coachSSO_tab_home: 'Home',
  coachSSO_tab_safetyEvents: 'Safety Events',
  coachSSO_tab_trips: 'Trips',
  coachSSO_tab_liveView: 'Live View',
  coachSSO_tab_coaching: 'Coaching',
  coachSSO_tab_videoRequests: 'Video Request',
  coachSSO_tab_challenges: 'Challenges',
  coachSSO_tab_reports: 'Reports',
  coachSSO_tab_configurations: 'Configurations',
};
